// Header
export const CHECK = "check";
export const DOCUMENT_TYPE = "documentTypeId";
export const SMALL_VARIANCE_GL = "smallVarianceCglId";
export const VARIANCE_AMT = "varianceAmount";
export const PROPERTY_ID = "propertyId";
export const OWNERSHIP_ID = "ownershipId";
export const REMARK = "remark";
export const COMMUNITY_ID = "communityId";
export const POSTING_MONTH = "postingPeriod";
export const POSTING_YEAR = "postingYear";
export const ACCOUNT_NAME = "accountName";
export const DOCUMENT_ID = "documentId";

// line items
export const LINE_ITEMS = "clearingTargetIds";
export const LINE_ITEM_ID = "customerSubledgerId";
export const GL_ACCOUNT = "glMasterId";
export const DOC_DATE = "postingDate";
export const DOC_NO = "postDocumentHeaderId";
export const DOC_TYPE = "documentType";
export const DUE_DATE = "dueDate";
export const PAYMENT_METHOD = "paymentMethod";
export const AMOUNT = "amount";
export const CLEARING_AMOUNT = "clearingAmount";
export const PAY_BLOCK = "paymentBlock";
export const DRCR = "drCr";
export const LINE_ITEM_TYPE = "lineItemType";

export const drcrOptions = [
  { label: "Dr", value: "DR" },
  { label: "Cr", value: "CR" },
];
